module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('h1', [_vm._v("Straight Fire 🔥")]), _c('p', [_vm._v("Trolling the internet for the best burns")]), _c('p', [_vm._v(" ")]), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/esist/comments/6rkj9n/hes_the_opposite_of_teddy_roosevelt_a_former/dl5y15w/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/politics/comments/6qzwd7/trump_told_golf_club_members_that_the_white_house/dl19wvc/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/politics/comments/6r5v2t/poll_trump_hits_new_low_at_33_percent_approval/dl2ip3q/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/worldnews/comments/6c5ovz/nytimes_trump_told_russians_that_firing_nut_job/dhs50di/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/worldnews/comments/6bv4f9/trump_campaign_had_at_least_18_undisclosed/dhprbfv/"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-961318c0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Burn.vue
// module id = 1085
// module chunks = 1